import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";

export default function PageTitle({ title = "" }) {
  const [pageTitle, setPageTitle] = useState("");

  useEffect(() => {
    setPageTitle(title);
  }, [title]);

  return (
    <Helmet>
      <title>{pageTitle ? pageTitle + " | " : ""} Aurobil Cars</title>
    </Helmet>
  );
}
